
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/discover-more/roadmap",
      function () {
        return require("private-next-pages/material-ui/discover-more/roadmap.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/discover-more/roadmap"])
      });
    }
  